import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const PageContainer = styled(Box)({
    display: 'flex',
    padding: '16px',
    gap: '16px',
    height: '100vh',
});

export const ContentContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'activeTab',
})(({ activeTab }) => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
}));
